import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmViewItemListEvent from 'utils/gtm/gtmViewItemListEvent';
import { setGtmProductsDataAction } from '../slice';
import getCurrentResults from '../selector/getCurrentResults';
import getGtmSearchProductsData from '../selector/getGtmSearchProuctsData';

const fetchGtmDataForCategory = async (categoryId: number, designIds: string[], quantity: number) => {
  return apiRequest(
    endpoints.categoryGtmProducts,
    {
      categoryId,
      designIds: designIds.join(','),
      quantity,
    },
    HttpMethods.GET,
    'payload',
  );
};

const fetchGTMSearchProductsDataOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    let store = getState();
    const results = getCurrentResults(store);
    const { products } = results;
    if (!products.length) {
      return;
    }
    const quantity = 1;

    // create a map for fetching gtm data for each categoryID
    const categoryProducts: Map<number, string[]> = new Map();

    products.forEach((product) => {
      const { categoryId, encDesignId } = product;
      if (!categoryProducts.has(categoryId)) {
        categoryProducts.set(categoryId, []);
      }
      encDesignId && categoryProducts.get(categoryId)?.push(encDesignId);
    });

    const fetchCalls = [...categoryProducts.entries()].map(([categoryId, designIds]) =>
      fetchGtmDataForCategory(categoryId, designIds, quantity),
    );

    await Promise.all(fetchCalls).then((res) => {
      res.forEach((gtmProducts: any) => {
        dispatch(setGtmProductsDataAction({ gtmProducts, merge: true }));
      });
    });

    // fetch that stored gtm data and send gtm event
    const designIds = [
      ...new Set(products.filter((product) => product.encDesignId).map((product) => product.encDesignId)),
    ] as string[];

    store = getState();
    const gtmSearchProductsData = getGtmSearchProductsData(store);

    gtmSendEvent(gtmViewItemListEvent(gtmSearchProductsData, designIds));
  };

export default fetchGTMSearchProductsDataOperation;
